import { render, staticRenderFns } from "./OverviewTableResume.vue?vue&type=template&id=2825610e&scoped=true&"
import script from "./OverviewTableResume.vue?vue&type=script&lang=ts&"
export * from "./OverviewTableResume.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewTableResume.vue?vue&type=style&index=0&id=2825610e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825610e",
  null
  
)

export default component.exports